import { render, staticRenderFns } from "./CalendarColored.vue?vue&type=template&id=7b027d1a&scoped=true"
import script from "./CalendarColored.vue?vue&type=script&lang=js"
export * from "./CalendarColored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b027d1a",
  null
  
)

export default component.exports